import { useMemo, useState } from "react";
import { scenes, sceneTags } from "@/mocks/siteContent";

const bandColor = [
  "from-primary-400 to-primary-600",
  "from-accent-400 to-accent-600",
  "from-secondary-400 to-secondary-600",
];

const tagColor: Record<string, string> = {
  吃瓜回顾: "bg-primary-100 text-primary-700 border-primary-200",
  素材收集: "bg-accent-100 text-accent-700 border-accent-200",
  资料存档: "bg-secondary-100 text-secondary-800 border-secondary-200",
  内容分析: "bg-foreground-100 text-foreground-700 border-foreground-200",
};

export default function Scenes() {
  const [active, setActive] = useState("全部场景");

  const list = useMemo(
    () => (active === "全部场景" ? scenes : scenes.filter((s) => s.tag === active)),
    [active]
  );

  return (
    <section id="scenes" className="section-pad scroll-mt-20 bg-background-100">
      <div className="container-x">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-medium tracking-wide text-primary-600">适用场景</p>
            <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">总有人比你更需要它</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              不管是追更吃瓜还是日常搬砖，页面素材都能被更好地留存与复用。
            </p>
          </div>
          <div
            className="flex flex-wrap gap-1.5 rounded-full border border-background-200 bg-background-50 p-1.5"
            role="group"
            aria-label="按场景筛选"
          >
            {sceneTags.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setActive(t)}
                aria-pressed={active === t}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === t ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <p className="mt-6 text-xs text-foreground-500">
          当前显示 <span className="font-bold text-primary-600">{list.length}</span> 个场景
        </p>

        <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s, i) => (
            <article
              key={s.title}
              className="group overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`h-1.5 bg-gradient-to-r ${bandColor[i % bandColor.length]}`} />
              <div className="p-6">
                <span
                  className={`inline-flex rounded-full border px-3 py-1 text-[11px] font-medium ${tagColor[s.tag]}`}
                >
                  {s.tag}
                </span>
                <h3 className="mt-3 text-lg font-bold text-foreground-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                <div className="mt-5 flex items-center gap-2 text-xs font-medium text-primary-600">
                  <span>适用于该场景</span>
                  <i className="ri-arrow-right-line text-sm transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}